<template>
  <div>
    <neu-cards-slider2 class="section py-lg-5 py-0  mx-auto" :cards="cards" :blackTitle="$t('abogalitypro.cards.title')" :title="$t('abogalitypro.cards.subtitle')" :iconsColor="ORANGE_COLOUR"></neu-cards-slider2>
    <base-button class="btn mx-auto" style="margin-bottom: 5rem;display:block" blue outline @click="() => { }"><span>{{ $t('abogalitypro.register-for-free') }}</span></base-button>
  </div>
</template>

<script>
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2'
import { ORANGE_COLOUR } from '@/constants/colours'

export default {
  components: {
    NeuCardsSlider2
  },
  data () {
    return {
      ORANGE_COLOUR,
      cards: [
        {
          title: this.$t('abogalitypro.cards.video.title'),
          subtitle: this.$t('abogalitypro.cards.video.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_VIDEOCONSULTA_AZUL.svg'
        },
        {
          title: this.$t('abogalitypro.cards.1.title'),
          subtitle: this.$t('abogalitypro.cards.1.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/www.svg'
        },
        {
          title: this.$t('abogalitypro.cards.2.title'),
          subtitle: this.$t('abogalitypro.cards.2.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/padlock.svg'
        },
        {
          title: this.$t('abogalitypro.cards.3.title'),
          subtitle: this.$t('abogalitypro.cards.3.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/chat.svg'
        },
        {
          title: this.$t('abogalitypro.cards.4.title'),
          subtitle: this.$t('abogalitypro.cards.4.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_HISTORIAL_CLINICO.svg'
        },
        {
          title: this.$t('abogalitypro.cards.5.title'),
          subtitle: this.$t('abogalitypro.cards.5.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/credit-card.svg'
        },
        {
          title: this.$t('abogalitypro.cards.6.title'),
          subtitle: this.$t('abogalitypro.cards.6.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_CALENDARIO.svg'
        },
        {
          title: this.$t('abogalitypro.cards.7.title'),
          subtitle: this.$t('abogalitypro.cards.7.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_OPENSALUD_PASS.svg'
        },
        {
          title: this.$t('abogalitypro.cards.8.title'),
          subtitle: this.$t('abogalitypro.cards.8.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/bell.svg'
        },
        {
          title: this.$t('abogalitypro.cards.9.title'),
          subtitle: this.$t('abogalitypro.cards.9.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg'
        },
        {
          title: this.$t('abogalitypro.cards.19.title'),
          subtitle: this.$t('abogalitypro.cards.10.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/interconsultations.svg'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

.section {
  // Fixes overflow on third card

  
  @include desktop-sm {
    padding: {
      right: 5rem !important;
      left: 5rem !important;
    }

    /deep/ .carousel-container {
      width: 100%;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/AbogalityCardsSlider.vue